goog.provide("shadow.js.shim.module$src$svg$chevron$chevron_left_svg");
goog.provide("module$shadow_js_shim_module$src$svg$chevron$chevron_left_svg");
shadow.js.shim.module$src$svg$chevron$chevron_left_svg = shadow.js.nativeProvides["src/svg/chevron/chevron-left.svg"] = shadow$bridge("src/svg/chevron/chevron-left.svg");
module$shadow_js_shim_module$src$svg$chevron$chevron_left_svg.default = shadow.js.shim.module$src$svg$chevron$chevron_left_svg;
